import i18next from 'i18next'
import {SelectItem} from '@/components/dumb/Select'
import {SearchParams} from '@/stores/transactions/OnlinePaymentsStore/models'
import {TRANSACTION_ID_PATTERN} from '@/constants/patterns'

export const searchOptions: () => SelectItem[] = () => [
    {
        label: i18next.t('OnlinePayments.searchFilter.order'),
        value: SearchParams.ORDER
    },
    {
        label: i18next.t('OnlinePayments.searchFilter.description'),
        value: SearchParams.DESCRIPTION
    },
    {
        label: i18next.t('OnlinePayments.searchFilter.customerName'),
        value: SearchParams.CUSTOMER_NAME
    },
    {
        label: i18next.t('OnlinePayments.searchFilter.email.startsWith'),
        value: SearchParams.EMAIL_STARTS_WITH
    },
    {
        label: i18next.t('OnlinePayments.searchFilter.card.startsWith'),
        value: SearchParams.CARD_STARTS_WITH
    },
    {
        label: i18next.t('OnlinePayments.searchFilter.card.endsWith'),
        value: SearchParams.CARD_ENDS_WITH
    },
    {
        label: i18next.t('OnlinePayments.searchFilter.customerAccountId'),
        value: SearchParams.CUSTOMER_ACCOUNT_ID
    },
    {
        label: i18next.t('OnlinePayments.searchFilter.transactionId'),
        value: SearchParams.TRANSACTION_ID
    }
]

export const searchValidation = () => ({
    [SearchParams.TRANSACTION_ID]: {
        pattern: TRANSACTION_ID_PATTERN,
        error: i18next.t('OnlinePayments.searchFilterErrors.transactionId')
    }
})
